export default "__VITE_ASSET__CTtZtyet__"